"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComptrollerStorage__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "PAUSER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "accountAssets",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "allMarkets",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        name: "assetGroup",
        outputs: [
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                internalType: "uint16",
                name: "intraCRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "intraMintRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "intraSuRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "interCRatePercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "interSuRatePercent",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "compLogic",
        outputs: [
            {
                internalType: "contract ICompLogic",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "globalConfig",
        outputs: [
            {
                internalType: "uint16",
                name: "closeFactorPercent",
                type: "uint16",
            },
            {
                internalType: "uint32",
                name: "minCloseValue",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "minSuBorrowValue",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "minWaitBeforeLiquidatable",
                type: "uint32",
            },
            {
                internalType: "uint8",
                name: "largestGroupId",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "interMintAllowed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isComptroller",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastBorrowedAt",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidationIncentive",
        outputs: [
            {
                internalType: "uint16",
                name: "heteroPercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "homoPercent",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "sutokenPercent",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "marketConfig",
        outputs: [
            {
                internalType: "bool",
                name: "mintPaused",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "borrowPaused",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "transferPaused",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "seizePaused",
                type: "bool",
            },
            {
                internalType: "uint120",
                name: "borrowCap",
                type: "uint120",
            },
            {
                internalType: "uint120",
                name: "supplyCap",
                type: "uint120",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "markets",
        outputs: [
            {
                internalType: "bool",
                name: "isListed",
                type: "bool",
            },
            {
                internalType: "uint8",
                name: "assetGroupId",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "isComped",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "contract IPriceOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pauseGuardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "redemptionManager",
        outputs: [
            {
                internalType: "contract IRedemptionManager",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ComptrollerStorage__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.ComptrollerStorage__factory = ComptrollerStorage__factory;
ComptrollerStorage__factory.bytecode = _bytecode;
ComptrollerStorage__factory.abi = _abi;
//# sourceMappingURL=ComptrollerStorage__factory.js.map